<div class="user-container">
  <div class="user-label">
    {{ userName }}
  </div>
  <mat-icon> person </mat-icon>
</div>
